var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpacebugPopup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 309,
    height: 541,
    viewBox: "0 0 309 541",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_714_7476)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 309,
    height: 541,
    fill: "url(#paint0_radial_714_7476)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M388.504 -2257L155 412L-78.5037 -2257H388.504ZM-977.073 -2016.19L155 412L-538.422 -2175.89L-977.073 -2016.19ZM-1739.46 -1482.46L155 412L-1381.71 -1782.68L-1739.46 -1482.46ZM-2273.19 -720.073L155 412L-2039.68 -1124.71L-2273.19 -720.073ZM-2514 178.716L155 412L-2432.89 -281.422L-2514 178.716ZM-2432.89 1105.64L155 412L-2514 645.504L-2432.89 1105.64ZM-2039.68 1948.93L155 412L-2273.19 1544.07L-2039.68 1948.93ZM-1381.71 2606.68L155 412L-1739.46 2306.46L-1381.71 2606.68ZM-538.422 2999.94L155 412L-977.073 2840.19L-538.422 2999.94ZM388.504 3081L155 412L-78.5037 3081H388.504ZM1287.07 2840.19L155 412L848.423 2999.94L1287.07 2840.19ZM2049.24 2306.46L155 412L1691.71 2606.68L2049.24 2306.46ZM2583.19 1544.07L155 412L2349.68 1948.71L2583.19 1544.07ZM2824 645.284L155 412L2742.94 1105.42L2824 645.284ZM2742.94 -281.422L155 412L2824 178.496L2742.94 -281.422ZM2349.68 -1124.71L155 412L2583.19 -720.073L2349.68 -1124.71ZM1691.71 -1782.68L155 412L2049.46 -1482.46L1691.71 -1782.68ZM848.423 -2175.89L155 412L1287.07 -2016.19L848.423 -2175.89Z",
    fill: "url(#paint1_radial_714_7476)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 392.5,
    r: 157.486,
    transform: "rotate(-53.0944 55.5 392.5)",
    fill: "url(#paint2_radial_714_7476)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_714_7476)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 55.5006,
    cy: 392.5,
    r: 119.847,
    transform: "rotate(120 55.5006 392.5)",
    fill: "url(#paint3_radial_714_7476)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_714_7476)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 55.4707,
    cy: 392.469,
    r: 114.186,
    transform: "rotate(-180 55.4707 392.469)",
    fill: "url(#paint4_radial_714_7476)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_714_7476)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.1874 322.131C53.9855 320.242 56.6629 320.242 57.461 322.131L77.3064 369.109C77.5414 369.665 77.9841 370.108 78.5405 370.343L125.518 390.188C127.407 390.986 127.407 393.664 125.518 394.462L78.5405 414.307C77.9841 414.542 77.5414 414.985 77.3064 415.541L57.461 462.519C56.6629 464.408 53.9855 464.408 53.1874 462.519L33.342 415.541C33.107 414.985 32.6643 414.542 32.1079 414.307L-14.8696 394.462C-16.7589 393.664 -16.7589 390.986 -14.8696 390.188L32.1079 370.343C32.6643 370.108 33.107 369.665 33.342 369.109L53.1874 322.131Z",
    fill: "url(#paint5_linear_714_7476)",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M99.8874 335.316C100.037 334.912 100.608 334.912 100.758 335.316L103.391 342.434C103.438 342.561 103.539 342.661 103.666 342.708L110.784 345.342C111.187 345.491 111.187 346.062 110.784 346.212L103.666 348.846C103.539 348.893 103.438 348.993 103.391 349.12L100.758 356.238C100.608 356.642 100.037 356.642 99.8874 356.238L97.2535 349.12C97.2065 348.993 97.1063 348.893 96.9794 348.846L89.8614 346.212C89.4575 346.062 89.4575 345.491 89.8614 345.342L96.9794 342.708C97.1063 342.661 97.2065 342.561 97.2535 342.434L99.8874 335.316Z",
    fill: "url(#paint6_linear_714_7476)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 214.454,
    cy: 482.453,
    r: 119.921,
    transform: "rotate(-8.09435 214.454 482.453)",
    fill: "url(#paint7_radial_714_7476)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_714_7476)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 214.454,
    cy: 482.454,
    r: 91.2603,
    transform: "rotate(165 214.454 482.454)",
    fill: "url(#paint8_radial_714_7476)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_714_7476)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 214.453,
    cy: 482.42,
    r: 86.9492,
    transform: "rotate(-135 214.453 482.42)",
    fill: "url(#paint9_radial_714_7476)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_714_7476)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.884 443.811C251.785 443.04 253.678 444.933 252.906 446.833L238.874 481.392C238.647 481.951 238.647 482.577 238.874 483.137L252.906 517.696C253.678 519.596 251.785 521.489 249.884 520.718L215.326 506.686C214.766 506.458 214.14 506.458 213.58 506.686L179.022 520.718C177.122 521.489 175.228 519.596 176 517.696L190.032 483.137C190.259 482.577 190.259 481.951 190.032 481.392L176 446.833C175.228 444.933 177.122 443.04 179.022 443.811L213.58 457.843C214.14 458.07 214.766 458.07 215.326 457.843L249.884 443.811Z",
    fill: "url(#paint10_linear_714_7476)",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M268.873 475.688C269.264 475.508 269.668 475.912 269.488 476.303L267.22 481.236C267.163 481.359 267.163 481.5 267.22 481.623L269.488 486.556C269.668 486.948 269.264 487.352 268.873 487.172L263.94 484.903C263.817 484.847 263.675 484.847 263.552 484.903L258.619 487.172C258.228 487.352 257.824 486.948 258.004 486.556L260.272 481.623C260.329 481.5 260.329 481.359 260.272 481.236L258.004 476.303C257.824 475.912 258.228 475.508 258.619 475.688L263.552 477.956C263.675 478.012 263.817 478.012 263.94 477.956L268.873 475.688Z",
    fill: "url(#paint11_linear_714_7476)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7533 142.28C53.6999 142.28 51.8599 141.947 50.2333 141.28C48.6066 140.613 47.2999 139.627 46.3133 138.32C45.3533 137.013 44.8466 135.44 44.7933 133.6H52.0733C52.1799 134.64 52.5399 135.44 53.1533 136C53.7666 136.533 54.5666 136.8 55.5533 136.8C56.5666 136.8 57.3666 136.573 57.9533 136.12C58.5399 135.64 58.8333 134.987 58.8333 134.16C58.8333 133.467 58.5933 132.893 58.1133 132.44C57.6599 131.987 57.0866 131.613 56.3933 131.32C55.7266 131.027 54.7666 130.693 53.5133 130.32C51.6999 129.76 50.2199 129.2 49.0733 128.64C47.9266 128.08 46.9399 127.253 46.1133 126.16C45.2866 125.067 44.8733 123.64 44.8733 121.88C44.8733 119.267 45.8199 117.227 47.7133 115.76C49.6066 114.267 52.0733 113.52 55.1133 113.52C58.2066 113.52 60.6999 114.267 62.5933 115.76C64.4866 117.227 65.4999 119.28 65.6333 121.92H58.2333C58.1799 121.013 57.8466 120.307 57.2333 119.8C56.6199 119.267 55.8333 119 54.8733 119C54.0466 119 53.3799 119.227 52.8733 119.68C52.3666 120.107 52.1133 120.733 52.1133 121.56C52.1133 122.467 52.5399 123.173 53.3933 123.68C54.2466 124.187 55.5799 124.733 57.3933 125.32C59.2066 125.933 60.6733 126.52 61.7933 127.08C62.9399 127.64 63.9266 128.453 64.7533 129.52C65.5799 130.587 65.9933 131.96 65.9933 133.64C65.9933 135.24 65.5799 136.693 64.7533 138C63.9533 139.307 62.7799 140.347 61.2333 141.12C59.6866 141.893 57.8599 142.28 55.7533 142.28ZM77.0427 122.84C77.7093 121.8 78.6293 120.96 79.8027 120.32C80.976 119.68 82.3493 119.36 83.9227 119.36C85.7627 119.36 87.4293 119.827 88.9227 120.76C90.416 121.693 91.5893 123.027 92.4427 124.76C93.3227 126.493 93.7627 128.507 93.7627 130.8C93.7627 133.093 93.3227 135.12 92.4427 136.88C91.5893 138.613 90.416 139.96 88.9227 140.92C87.4293 141.853 85.7627 142.32 83.9227 142.32C82.376 142.32 81.0027 142 79.8027 141.36C78.6293 140.72 77.7093 139.893 77.0427 138.88V152.64H70.2027V119.68H77.0427V122.84ZM86.8027 130.8C86.8027 129.093 86.3227 127.76 85.3627 126.8C84.4293 125.813 83.2693 125.32 81.8827 125.32C80.5227 125.32 79.3627 125.813 78.4027 126.8C77.4693 127.787 77.0027 129.133 77.0027 130.84C77.0027 132.547 77.4693 133.893 78.4027 134.88C79.3627 135.867 80.5227 136.36 81.8827 136.36C83.2427 136.36 84.4027 135.867 85.3627 134.88C86.3227 133.867 86.8027 132.507 86.8027 130.8ZM95.9911 130.8C95.9911 128.507 96.4178 126.493 97.2711 124.76C98.1511 123.027 99.3378 121.693 100.831 120.76C102.324 119.827 103.991 119.36 105.831 119.36C107.404 119.36 108.778 119.68 109.951 120.32C111.151 120.96 112.071 121.8 112.711 122.84V119.68H119.551V142H112.711V138.84C112.044 139.88 111.111 140.72 109.911 141.36C108.738 142 107.364 142.32 105.791 142.32C103.978 142.32 102.324 141.853 100.831 140.92C99.3378 139.96 98.1511 138.613 97.2711 136.88C96.4178 135.12 95.9911 133.093 95.9911 130.8ZM112.711 130.84C112.711 129.133 112.231 127.787 111.271 126.8C110.338 125.813 109.191 125.32 107.831 125.32C106.471 125.32 105.311 125.813 104.351 126.8C103.418 127.76 102.951 129.093 102.951 130.8C102.951 132.507 103.418 133.867 104.351 134.88C105.311 135.867 106.471 136.36 107.831 136.36C109.191 136.36 110.338 135.867 111.271 134.88C112.231 133.893 112.711 132.547 112.711 130.84ZM123.14 130.84C123.14 128.52 123.606 126.493 124.54 124.76C125.5 123.027 126.82 121.693 128.5 120.76C130.206 119.827 132.153 119.36 134.34 119.36C137.14 119.36 139.473 120.093 141.34 121.56C143.233 123.027 144.473 125.093 145.06 127.76H137.78C137.166 126.053 135.98 125.2 134.22 125.2C132.966 125.2 131.966 125.693 131.22 126.68C130.473 127.64 130.1 129.027 130.1 130.84C130.1 132.653 130.473 134.053 131.22 135.04C131.966 136 132.966 136.48 134.22 136.48C135.98 136.48 137.166 135.627 137.78 133.92H145.06C144.473 136.533 143.233 138.587 141.34 140.08C139.446 141.573 137.113 142.32 134.34 142.32C132.153 142.32 130.206 141.853 128.5 140.92C126.82 139.987 125.5 138.653 124.54 136.92C123.606 135.187 123.14 133.16 123.14 130.84ZM169.758 130.48C169.758 131.12 169.718 131.787 169.638 132.48H154.158C154.265 133.867 154.705 134.933 155.478 135.68C156.278 136.4 157.252 136.76 158.398 136.76C160.105 136.76 161.292 136.04 161.958 134.6H169.238C168.865 136.067 168.185 137.387 167.198 138.56C166.238 139.733 165.025 140.653 163.558 141.32C162.092 141.987 160.452 142.32 158.638 142.32C156.452 142.32 154.505 141.853 152.798 140.92C151.092 139.987 149.758 138.653 148.798 136.92C147.838 135.187 147.358 133.16 147.358 130.84C147.358 128.52 147.825 126.493 148.758 124.76C149.718 123.027 151.052 121.693 152.758 120.76C154.465 119.827 156.425 119.36 158.638 119.36C160.798 119.36 162.718 119.813 164.398 120.72C166.078 121.627 167.385 122.92 168.318 124.6C169.278 126.28 169.758 128.24 169.758 130.48ZM162.758 128.68C162.758 127.507 162.358 126.573 161.558 125.88C160.758 125.187 159.758 124.84 158.558 124.84C157.412 124.84 156.438 125.173 155.638 125.84C154.865 126.507 154.385 127.453 154.198 128.68H162.758ZM187.927 127.64C188.94 127.8 189.86 128.213 190.687 128.88C191.54 129.547 192.207 130.373 192.687 131.36C193.193 132.347 193.447 133.4 193.447 134.52C193.447 135.933 193.087 137.213 192.367 138.36C191.647 139.48 190.593 140.373 189.207 141.04C187.847 141.68 186.233 142 184.367 142H173.967V114.12H183.967C185.86 114.12 187.473 114.44 188.807 115.08C190.14 115.693 191.14 116.533 191.807 117.6C192.473 118.667 192.807 119.867 192.807 121.2C192.807 122.853 192.353 124.227 191.447 125.32C190.567 126.387 189.393 127.16 187.927 127.64ZM177.607 126.16H183.727C185.433 126.16 186.753 125.76 187.687 124.96C188.62 124.16 189.087 123.053 189.087 121.64C189.087 120.227 188.62 119.12 187.687 118.32C186.753 117.52 185.407 117.12 183.647 117.12H177.607V126.16ZM184.047 139C185.86 139 187.273 138.573 188.287 137.72C189.3 136.867 189.807 135.68 189.807 134.16C189.807 132.613 189.273 131.4 188.207 130.52C187.14 129.613 185.713 129.16 183.927 129.16H177.607V139H184.047ZM217.938 120.08V142H214.298V138.76C213.605 139.88 212.631 140.76 211.378 141.4C210.151 142.013 208.791 142.32 207.298 142.32C205.591 142.32 204.058 141.973 202.698 141.28C201.338 140.56 200.258 139.493 199.458 138.08C198.685 136.667 198.298 134.947 198.298 132.92V120.08H201.898V132.44C201.898 134.6 202.445 136.267 203.538 137.44C204.631 138.587 206.125 139.16 208.018 139.16C209.965 139.16 211.498 138.56 212.618 137.36C213.738 136.16 214.298 134.413 214.298 132.12V120.08H217.938ZM222.724 131C222.724 128.733 223.177 126.76 224.084 125.08C224.991 123.373 226.244 122.053 227.844 121.12C229.471 120.187 231.324 119.72 233.404 119.72C236.097 119.72 238.311 120.373 240.044 121.68C241.804 122.987 242.964 124.8 243.524 127.12H239.604C239.231 125.787 238.497 124.733 237.404 123.96C236.337 123.187 235.004 122.8 233.404 122.8C231.324 122.8 229.644 123.52 228.364 124.96C227.084 126.373 226.444 128.387 226.444 131C226.444 133.64 227.084 135.68 228.364 137.12C229.644 138.56 231.324 139.28 233.404 139.28C235.004 139.28 236.337 138.907 237.404 138.16C238.471 137.413 239.204 136.347 239.604 134.96H243.524C242.937 137.2 241.764 139 240.004 140.36C238.244 141.693 236.044 142.36 233.404 142.36C231.324 142.36 229.471 141.893 227.844 140.96C226.244 140.027 224.991 138.707 224.084 137C223.177 135.293 222.724 133.293 222.724 131ZM260.621 142L252.021 132.32V142H248.381V112.4H252.021V129.8L260.461 120.08H265.541L255.221 131L265.581 142H260.621Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2018 162.176C88.3513 161.772 88.9225 161.772 89.072 162.176L91.7059 169.294C91.7529 169.421 91.853 169.521 91.98 169.568L99.098 172.202C99.5019 172.351 99.5019 172.923 99.098 173.072L91.98 175.706C91.853 175.753 91.7529 175.853 91.7059 175.98L89.072 183.098C88.9225 183.502 88.3513 183.502 88.2018 183.098L85.5679 175.98C85.5209 175.853 85.4208 175.753 85.2938 175.706L78.1758 173.072C77.7719 172.923 77.7719 172.351 78.1758 172.202L85.2938 169.568C85.4208 169.521 85.5209 169.421 85.5679 169.294L88.2018 162.176Z",
    fill: "url(#paint12_linear_714_7476)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.065 53.1758C215.214 52.7719 215.786 52.7719 215.935 53.1758L218.262 59.464C218.309 59.591 218.409 59.6911 218.536 59.7381L224.824 62.0649C225.228 62.2144 225.228 62.7856 224.824 62.9351L218.536 65.2619C218.409 65.3089 218.309 65.409 218.262 65.536L215.935 71.8242C215.786 72.2281 215.214 72.2281 215.065 71.8242L212.738 65.536C212.691 65.409 212.591 65.3089 212.464 65.2619L206.176 62.9351C205.772 62.7856 205.772 62.2144 206.176 62.0649L212.464 59.7381C212.591 59.6911 212.691 59.591 212.738 59.464L215.065 53.1758Z",
    fill: "url(#paint13_linear_714_7476)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.065 65.1758C239.214 64.7719 239.786 64.7719 239.935 65.1758L244.693 78.0332C244.74 78.1602 244.84 78.2603 244.967 78.3073L257.824 83.0649C258.228 83.2144 258.228 83.7856 257.824 83.9351L244.967 88.6927C244.84 88.7397 244.74 88.8398 244.693 88.9668L239.935 101.824C239.786 102.228 239.214 102.228 239.065 101.824L234.307 88.9668C234.26 88.8398 234.16 88.7397 234.033 88.6927L221.176 83.9351C220.772 83.7856 220.772 83.2144 221.176 83.0649L234.033 78.3073C234.16 78.2603 234.26 78.1602 234.307 78.0332L239.065 65.1758Z",
    fill: "url(#paint14_linear_714_7476)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_714_7476",
    x: -64.3672,
    y: 272.633,
    width: 239.734,
    height: 239.734,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.8557
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_714_7476"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_714_7476",
    x: -58.7148,
    y: 278.283,
    width: 228.371,
    height: 228.371,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.8557
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_714_7476"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_714_7476",
    x: -22.5501,
    y: 315.379,
    width: 155.749,
    height: 155.747,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.927852
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.1315
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.420347 0 0 0 0 0.271927 0 0 0 0 0.945833 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_714_7476"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_714_7476",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_714_7476",
    x: 123.172,
    y: 391.171,
    width: 182.564,
    height: 182.566,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.8557
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_714_7476"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_714_7476",
    x: 127.504,
    y: 395.471,
    width: 173.898,
    height: 173.898,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.8557
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_714_7476"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_714_7476",
    x: 169.561,
    y: 438.299,
    width: 89.7838,
    height: 89.7855,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.927852
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.1315
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.420347 0 0 0 0 0.271927 0 0 0 0 0.945833 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_714_7476"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_714_7476",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_714_7476",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97 99.5) rotate(85.331) scale(429.659 429.659)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F4AF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.569993,
    stopColor: "#1B0664"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#120051"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_714_7476",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(155 412) rotate(64.659) scale(599.505)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.930229,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_714_7476",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(92.325 250.449) rotate(101.579) scale(297.875)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B49EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.565625,
    stopColor: "#6F4AF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815625,
    stopColor: "#4623C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D118E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_714_7476",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(83.5245 284.399) rotate(101.579) scale(226.683)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B49EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.565625,
    stopColor: "#6F4AF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815625,
    stopColor: "#4623C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D118E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_714_7476",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(82.1707 289.474) rotate(101.579) scale(215.975)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B49EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.565625,
    stopColor: "#6F4AF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815625,
    stopColor: "#4623C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D118E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_714_7476",
    x1: 55.3242,
    y1: 317.073,
    x2: 55.3242,
    y2: 467.577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.22
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_714_7476",
    x1: 100.322,
    y1: 334.14,
    x2: 100.322,
    y2: 357.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B29DFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_714_7476",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(242.495 374.285) rotate(101.579) scale(226.823)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B49EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.565625,
    stopColor: "#6F4AF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815625,
    stopColor: "#4623C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D118E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_714_7476",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(235.793 400.137) rotate(101.579) scale(172.613)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B49EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.565625,
    stopColor: "#6F4AF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815625,
    stopColor: "#4623C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D118E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_714_7476",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(234.784 403.993) rotate(101.579) scale(164.459)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B49EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.565625,
    stopColor: "#6F4AF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815625,
    stopColor: "#4623C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D118E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_714_7476",
    x1: 254.972,
    y1: 441.746,
    x2: 173.934,
    y2: 522.783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.22
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_714_7476",
    x1: 270.012,
    y1: 475.164,
    x2: 257.48,
    y2: 487.695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B29DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_714_7476",
    x1: 88.6369,
    y1: 161,
    x2: 88.6369,
    y2: 184.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B29DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_714_7476",
    x1: 215.5,
    y1: 52,
    x2: 215.5,
    y2: 73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B29DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_714_7476",
    x1: 239.5,
    y1: 64,
    x2: 239.5,
    y2: 103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B29DFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_714_7476"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 309,
    height: 541,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpacebugPopup);
export default __webpack_public_path__ + "static/media/spacebug-popup.8f07753d6037f1f0654f8fd3d28b834d.svg";
export { ForwardRef as ReactComponent };